import type { AngleAffiche, AngleDOuverture } from '@nextilt/commun';
import { MOTS_DES_ANGLES_D_OUVERTURE } from '../partage/vocabulaire';

/**
 * Les angles d'une feuille, à l'ordinateur (chantier angles-du-projet, tickets 02 et 03) : comment
 * on regarde la bulle ouverte. Carte, Liste et Hiérarchie montrent le même contenu, autrement
 * rangé ; Agenda montre ce qui est daté dans la bulle ouverte, Maintenant ce que « Maintenant »
 * propose, limités à elle.
 *
 * L'ordre est celui de la maquette du carnet (`projet-ouvert.html`), Maintenant avant Agenda
 * (décision d'Igor du 2026-10-20) : c'est aussi celui où la touche v les parcourt. La liste des
 * angles est celle de `commun` (`ANGLES_AFFICHES`), que le journal des gestes croit (ticket 05).
 */
export type Vue = AngleAffiche;

/** Les repères du tuto de chaque onglet sont posés par l'écran, `BasculeVue.tsx`. */
export const ANGLES: readonly { vue: Vue; nom: string }[] = [
  { vue: 'carte', nom: MOTS_DES_ANGLES_D_OUVERTURE.carte },
  { vue: 'liste', nom: MOTS_DES_ANGLES_D_OUVERTURE.liste },
  { vue: 'hierarchie', nom: MOTS_DES_ANGLES_D_OUVERTURE.hierarchie },
  { vue: 'maintenant', nom: 'Maintenant' },
  { vue: 'agenda', nom: 'Agenda' },
];

/** L'angle suivant, pour la touche v : dans l'ordre des onglets, puis on recommence. */
export function angleSuivant(vue: Vue): Vue {
  const ici = ANGLES.findIndex((a) => a.vue === vue);
  return ANGLES[(ici + 1) % ANGLES.length]!.vue;
}

/**
 * Carte, Liste et Hiérarchie montrent l'arbre de la bulle ouverte ; Agenda et Maintenant, autre
 * chose. Ces deux-là n'ont rien à désigner : ni « Hiérarchiser », ni sa barre.
 */
export function montreLArbre(vue: Vue): boolean {
  return vue === 'carte' || vue === 'liste' || vue === 'hierarchie';
}

/**
 * L'angle d'une feuille quand on y arrive (chantier angle-a-l-ouverture, modification 02) :
 * entrer dans un projet, depuis la barre de gauche, la page Projets, l'accueil ou une autre page,
 * l'ouvre sur l'angle de son habit ; descendre ou remonter dans le même projet garde l'angle où
 * l'on est (`null` : rien ne change). `projetDOu` : le projet de la feuille d'avant, `null` en
 * arrivant d'une autre page. Une arrivée qui demande la Carte (l'Aide) passe après.
 */
export function angleALEntree(projetDOu: string | null, projet: string, angle: AngleDOuverture): Vue | null {
  return projetDOu === projet ? null : angle;
}
